import axios, { AxiosResponse, CancelToken } from "axios";
import { WorkerListRequest, WorkerResponse, WorkerChannelResponse } from "../../models/TwilioModels";

export const getTwilioWorkspaces = async (productId: string, subscriptionId: string, accountSid: string) => {
	return await axios.get(
		`/api/v1/${productId}/Twilio/WorkerLogs/${subscriptionId}/${accountSid}/GetWorkspacesForAccount`,
	);
};

export const getTwilioWorkers =
	(request: WorkerListRequest, subscriptionId: string, productId: string, accountSid: string) =>
	async (cancelToken?: CancelToken): Promise<AxiosResponse<WorkerResponse[]>> => {
		return await axios.post(
			`/api/v1/${productId}/Twilio/WorkerLogs/${subscriptionId}/${accountSid}/GetWorkersForWorkspaceSid`,
			request,
			{ cancelToken: cancelToken },
		);
	};

export const getTwilioWorkerChannels =
	(productId: string, subscriptionId: string, accountSid: string, workspaceSid: string, workerSid: string) =>
	async (): Promise<AxiosResponse<WorkerChannelResponse>> => {
		return await axios.get(
			`/api/v1/${productId}/Twilio/WorkerLogs/${subscriptionId}/${accountSid}/GetWorkerChannelsByWorkerSid/${workspaceSid}/${workerSid}`,
		);
	};
